import React, { FC } from "react";
import styles from "./Typography.module.scss";
import { TypographyProps } from "./Typography.types";

const Typography: FC<TypographyProps> = ({
  variant = "h2",
  token = 700,
  tokenMd,
  tokenSm,
  weight = "regular",
  children,
  ...props
}) => {
  const tokenLgStyle = {
    1000: styles.OneThousand,
    900: styles.NineHundred,
    800: styles.EightHundred,
    700: styles.SevenHundred,
    600: styles.SixHundred,
    500: styles.FiveHundred,
    400: styles.FourHundred,
    300: styles.ThreeHundred,
    200: styles.TwoHundred,
    100: styles.OneHundred,
    75: styles.SeventyFive,
    50: styles.Fifty,
  };
  const tokenMdStyle = {
    800: styles.EightHundredMd,
    700: styles.SevenHundredMd,
    600: styles.SixHundredMd,
    500: styles.FiveHundredMd,
    400: styles.FourHundredMd,
    300: styles.ThreeHundredMd,
    200: styles.TwoHundredMd,
    100: styles.OneHundredMd,
    75: styles.SeventyFiveMd,
    50: styles.FiftyMd,
  };
  const tokenSmStyle = {
    800: styles.EightHundredSm,
    700: styles.SevenHundredSm,
    600: styles.SixHundredSm,
    500: styles.FiveHundredSm,
    400: styles.FourHundredSm,
    300: styles.ThreeHundredSm,
    200: styles.TwoHundredSm,
    100: styles.OneHundredSm,
    75: styles.SeventyFiveSm,
    50: styles.FiftySm,
  };

  const classNames = `${styles.Typography} ${styles[weight]} ${
    tokenLgStyle[token]
  } ${tokenMd ? tokenMdStyle[tokenMd] : " "} ${
    tokenSm ? tokenSmStyle[tokenSm] : " "
  }`;

  return React.createElement(
    variant,
    { ...props, className: [classNames, props.className].join(" ") },
    children
  );
};

export default Typography;
